import { cn } from '@/lib/utils';

interface Props {
  value: number; // 0..100
  className?: string;
}

export function ProgressBar({ value, className }: Props) {
  const v = Math.max(0, Math.min(100, value));
  return (
    <div className={cn('h-2 bg-tg-secondaryBg rounded-full overflow-hidden', className)}>
      <div
        className="h-full bg-brand-orange rounded-full transition-all duration-500"
        style={{ width: `${v}%` }}
      />
    </div>
  );
}
